//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { date } from "quasar";
import { APP_DATE_DOT_FORMAT } from "@/assets/js/appConfig";
import AQAvatar from "@/components/Generics/AQAvatar/AQAvatar.vue";
import AQList from "../../../../../components/Generics/AQList/AQList.vue";

export default {
    components: {
        AQList,
        AQAvatar
    },
    filters: {
        dateFormatter(dateToFormat) {
            const newData = dateToFormat ? date.formatDate(dateToFormat, APP_DATE_DOT_FORMAT).split(" ") : "";
            let responseData = "";
            if (newData) {
                const [dateD, dateT] = newData;
                responseData = `${dateD} at ${dateT}`;
            }
            return responseData;
        }
    },
    props: {},
    data() {
        return {
            optionsMore: [{ name: "export", label: "Export" }, { name: "duplicate", label: "Duplicate" }, { name: "deleteOpt", label: "Delete" }],
            badgeColor: "var(--q-color-chip-default-text)",
            leftColor: "var(--q-color-warning-text)",
            hideList: ["edit", "delete"],
            nameApp: "nameApp",
            list: [{ name: "elem1", id: "1", mail: "elem1@yahoo.com", type: "externalGroup", avatarType: "userPlatform", lastLogin: "Text1" },
                { name: "elem2", id: "2", mail: "elem2@yahoo.com", type: "systemExternalUser", avatarType: "userPlatform", lastLogin: "Text2" },
                { name: "elem3", id: "3", mail: "elem3@yahoo.com", type: "systemExternalUser", avatarType: "externalUser", lastLogin: "Text2" }],
            listUsers: [{
                avatarPath: null,
                code: null,
                email: "admin@aurachain.ch",
                firstName: "admin",
                avatarType: "EXTERNAL",
                groups: null,
                id: "2c39c58f-b4a5-40a9-9826-9dce8b57a2fa",
                lastLoginDate: "2022-09-09T10:13:03.31098Z",
                lastName: "Admin",
                lastUpdate: "2022-06-28T08:25:57.193738",
                username: "admin@aurachain.ch",
                systemType: "TUSR",
                nameApp: "Aplicatie1",
                status: "Disabled",
                realmId: "123-567-980"

            },
            {
                avatarPath: "/aurachainStorage/users/Avatar/m_dfa5e24b-2beb-42e8-bd83-77820abace58.png",
                code: null,
                avatarType: "TUSR",
                email: "alexandru.cegorean@hq.aurachain.ch",
                firstName: "pepe",
                groups: null,
                id: "2c39c58f-b4a5-40a9-9826-9dce8b57a2fa",
                lastLoginDate: "2022-09-07T07:50:44.947439Z",
                lastName: "pepe",
                lastUpdate: "2022-06-28T08:25:57.193738",
                systemType: "SYSTEM",
                username: "alexandru.cegorean@hq.aurachain.ch",
                nameApp: "Aplicatie2",
                status: "Active"

            },
            {
                avatarPath: "",
                code: null,
                email: "alexandru.cego@hq.aurachain.ch",
                firstName: "Alex",
                avatarType: "systemExternalUser",
                groups: null,
                id: "394841bc-6a8a-4c43-92bb-6820b64835ce",
                lastLoginDate: "2022-09-07T07:50:44.947439Z",
                lastName: "LEX",
                lastUpdate: "2022-06-28T08:25:57.193738",
                systemType: "EXTERNAL",
                username: "alexandru.cegorean@hq.aurachain.ch",
                nameApp: "Aplicatie3",
                status: true

            }
            ],
            isBigList: false,
            customText: ""
        };
    },
    methods: {
        checkTogle() {
            this.isBigList = !this.isBigList;
        },
        editElement(value) {
            const name = value.name || value.nameApp;
            this.$toast.showNotify({
                type: "succes",
                message: `Edit ${name}`,
                timeout: 1000
            });
        },
        deleteElement(value) {
            this.$toast.showNotify({
                type: "error",
                message: `Delete ${value.name}`,
                timeout: 1000
            });
        },
        downloadElement(value) {
            this.$toast.showNotify({
                type: "info",
                message: `Download ${value.name}`,
                timeout: 1000
            });
        },
        copyElement(value) {
            this.$toast.showNotify({
                type: "info",
                message: `Copy ${value.name}`,
                timeout: 1000
            });
        },
        avatarProps() {
            return {
                defaultAvatar: "userPlatform",
                disabled: "status",
                type: "avatarType",
                customAvatar: "avatarPath",
                firstAvatar: { name: "realmId", value: "EXTERNAL" }
            };
        },
        propsRight() {
            return {
                badgeType: "systemType",
                badgeColor: this.badgeColor,
                firstBadge: { name: "realmId", value: "EXTERNAL" }
            };
        },
        propsLeft() {
            return {
                badgeText: "nameApp",
                badgeColor: this.badgeColor,
                noBorder: true,
                background: this.leftColor
            };
        },
        propsAvatarSlot(item) {
            return {
                type: item.avatarType,
                customAvatar: item.customAvatar
            };
        }

    }
};

